import React, { useMemo } from 'react';
import styles from './index.module.scss';
import DataTable from 'components/DataTable';
import { tableStyles } from 'css/tableStyles';

const SoldHistory = props => {
  const {
    soldHistory = [],
    nextPredictedSellquantity,
  } = props;
 
  const columns = useMemo(() => [
    {
      name: 'Week',
      selector: 'week',
      sortable: true,
    },
    {
      name: 'Quantity Sold',
      selector: 'quantitySold',
      sortable: true,
    },
  ], []);

  return (
    <div className={styles['sold-quantity-main-container']}>
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>Item sold history</div>
        <div>Next Predicted Sell Quantity: 
          <span className={styles['next-predicted-sell-quantity']}>{nextPredictedSellquantity}</span>
        </div>
      </div>
      <DataTable
        keyField= "week"
        columns={columns}
        noHeader={true}
        data={soldHistory}
        highlightOnHover={true}
        customStyles={tableStyles}
        pagination={false}
      />
    </div>
  );
};

export default SoldHistory;